import React from 'react'
import { useTranslation, withI18nContext } from '@mc/i18n'
import { TableFeature } from '@mc/plans-ui'
import { BOGO_I18N_NAMESPACE, i18nInstance } from '../../../i18n'

const BogoFeaturesTitleComp = () => {
  const { t } = useTranslation(BOGO_I18N_NAMESPACE)

  return (
    <TableFeature.Feature>
      <TableFeature.Header title={t('plans.rows.featuresHeader.title')} />
      <TableFeature.Individual />
      <TableFeature.Duo />
      <TableFeature.Family />
    </TableFeature.Feature>
  )
}

export const BogoFeaturesTitle = withI18nContext(i18nInstance)(
  BogoFeaturesTitleComp,
)
